import { render, staticRenderFns } from "./RealModal.vue?vue&type=template&id=1f495332&scoped=true&"
import script from "./RealModal.vue?vue&type=script&lang=ts&"
export * from "./RealModal.vue?vue&type=script&lang=ts&"
import style0 from "./RealModal.vue?vue&type=style&index=0&id=1f495332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f495332",
  null
  
)

export default component.exports